<template>
    <h2 class="heading">Personal Investment Details</h2>
    <div class="detail" style="min-width:900px">
        <table>
            <tr><th>Request No</th> <td>{{investment.id}}</td></tr>
            <tr><th>Title</th> <td>{{investment.title}}</td></tr>
            <tr><th>Creator</th> <td>{{investment.fullname}}</td></tr>
            <tr><th>Submitted at</th> <td>{{investment.createDate}}</td></tr>
            <tr><th>Status</th> <td :class="investment.status">{{investment.status}}</td></tr>
            <tr v-if="investment.contractChecked=='Yes'"><th>Contract checked</th> <td>{{investment.contractChecked}}</td></tr>
            <tr v-if="investment.contractChecked=='Yes'"><th>Checked time</th> <td>{{investment.checkedTime}}</td></tr>
            <tr v-if="global.hasRight('personal-investment', 'approver') && investment.status == 'pending' && investment.creator != global.currentUser.id ">
                <th>Review result</th> 
                <td>
                    <el-radio-group v-model="status">
                        <el-radio label="approved" class="approved"><b>approved</b></el-radio>
                        <el-radio label="rejected" class="rejected"><b>rejected</b></el-radio>
                    </el-radio-group>
                </td>
            </tr>
            <tr><th>Remarks</th> 
                <td>
                    <el-input v-if="global.hasRight('personal-investment', 'approver') && (investment.remark == null || investment.remark == '')" 
                        type="textarea" v-model="remark"/>
                    <span v-else style="line-height:1.6em; padding: 8px 0px;" v-html='investment.remark2'></span>
                </td>
            </tr>
            <tr><th>Items</th> 
                <td>
                    <table>
                        <tr>
                            <th>Trade</th><th>Ticker</th><th style="min-width:300px">Name</th><th>Type</th><th>Market</th><th>Quantity</th>
                            <th>Trade Amount</th><th>Trade Date</th><th>Attachment</th>
                        </tr>
                        <tr v-for="item in investment.detailList" :key="item.id">
                            <td>{{item.type}}</td>
                            <td>{{item.ticker}}</td>
                            <td>{{item.name}}
                                <el-button v-if="item.investType == 'other' && global.hasRight('personal-investment', 'approver')" 
                                    @click="addEtf(item)" type="success" style="margin-left:5px;" size="small">Add ETF</el-button>
                            </td>
                            <td>{{item.investType}}</td>
                            <td>{{item.market}}</td>
                            <td>{{item.quantity}}</td>
                            <td>{{item.tradeAmount}}</td>
                            <td>{{item.tradeDate}}</td>
                            <td><a href="" @click.prevent="global.down(item.attachments.split(':')[0], item.attachments.split(':')[1])" 
                                v-if="item.attachments && item.attachments.length">
                            {{item.attachments.split(':')[1]}}</a></td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>

        <div v-if="errMsg != ''" style="width:1024px;margin-top:15px;"><el-alert :title="errMsg" type="error" /></div>
        <div class="buttonDIV">
            <el-button v-if="investment.status == 'pending' && global.hasRight('personal-investment', 'approver') 
                && global.currentUser.id != investment.creator " 
                @click="approveInvestment" style="margin-right:10px;" type="primary">Submit</el-button>
            <el-button v-else-if="(investment.remark == '' ||  investment.remark == null) 
                && global.hasRight('personal-investment', 'approver')" 
                @click="saveRemark" style="margin-right:10px;" type="primary">Save Remark</el-button>
            <el-button @click="backInvestmentList">Back to list</el-button>
            <span v-if="loading" style="padding-left:20px; vertical-align:bottom;">
                <img src="@/assets/loading.gif" style="height:24px;"/>
            </span>
        </div>
    </div>


    <el-dialog v-model="dialogFormVisible" title="Add new ETF into Predefined List" width="660px" center>
        <el-form label-width="130px" style="width:600px" >
             <el-form-item label="Ticker" required>
                <el-input type="text" v-model="etf.ticker" placeholder="Ticker of ETF"/>
             </el-form-item>
             <el-form-item label="Fund Name" required>
                <el-input type="text" v-model="etf.name" placeholder="Fund name"/>
             </el-form-item>
            <el-form-item label="Asset Class" required>
                <el-select v-model="etf.assetClass" placeholder="Asset Class">
                    <el-option v-for="assetClass in assetClasses" :key="assetClass" :label="assetClass" :value="assetClass" />
                </el-select>
            </el-form-item>
            <el-form-item label="Country" required>
                <el-select v-model="etf.country" placeholder="Country">
                    <el-option v-for="country in countries" :key="country" :label="country" :value="country" />
                </el-select>
            </el-form-item>
            <el-form-item label="" v-if="errMsg != ''">
                <span class="errMsg" v-if="errMsg != ''">{{errMsg}}</span>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary" @click="savePredefinedETF">Submit</el-button>
                <span v-if="loading2" style="padding-left:20px; vertical-align:bottom;">
                    <img src="@/assets/loading.gif" style="height:24px;"/>
                </span>
            </span>
        </template>
    </el-dialog>
</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
const countries = ["Hong Kong", "United States", "Taiwan", "Japan", "South Korea", "Singapore",
                    "Canada", "Australia", "France", "Ireland", "Jersey", "Luxembourg", "Netherlands", "Other"];
const assetClasses = ["Equity", "Fixed Income", "Money Market", "Commodities", "Allocation", "Alternative", "Miscellaneous", "Other"];
export default {
    data() {
        return {
            etf: {ticker:null, name: null, assetClass: null, country: null, detailId: null},
            investment: {},
            status: null,
            remark: null,
            errMsg: '',
            code: null,
            countries,
            assetClasses,
            dialogFormVisible: false,
            item: null,
            loading: false,
            loading2: false,
            global,
        }
    },
    computed: {
        
    },
    async mounted() {
        this.global.index = "investment";
        this.code = this.$route.query.code;
        let result = await AXIOS("/investment/getInvestmentByCode", {code: this.code});
        if (result.success) {
            this.investment = result.data;
        }
    },

    methods: {
        addEtf(item) {
            this.etf.ticker = item.ticker;
            this.etf.name = item.name;
            this.dialogFormVisible = true;
            this.item = item;
        },
        async savePredefinedETF() {
            if (this.etf.ticker == "") {
                this.errMsg = "Ticker is required"; return;
            }
            if (this.etf.name == "") {
                this.errMsg = "Fund Name is required"; return;
            }
            if (this.etf.assetClass == null) {
                this.errMsg = "Please select Asset Class"; return;
            }
            if (this.etf.country == null) {
                this.errMsg = "Please select Country"; return;
            }

            if (this.loading2) return; // avoid repeat submit
            this.loading2 = true;
            this.etf["detailId"] = this.item.id;
            let result = await AXIOS("/investment/savePredefinedETF", this.etf);
            if (result.success) {
                this.dialogFormVisible = false;
                if (result.data != null && result.data.length == 32)
                    this.$router.push('/investment/viewInvestment?code='+result.data);
                else
                    this.item.investType = 'etf';
            }
            this.loading2 = false;
        },
        backInvestmentList() {
            let fromPath = sessionStorage.getItem("fromPath");
            if (fromPath && fromPath.startsWith("/investment/")) {
                this.$router.push(fromPath);
            } else {
               if (this.global.hasRight('personal-investment', 'approver')) {
                   this.$router.push('/investment/allInvestmentList');
               } else {
                   this.$router.push('/investment/myInvestmentList');
               }
            }
        },
        async saveRemark() {
            this.errMsg = '';
            if (this.remark == '' || this.remark == null) {
                this.errMsg = "Please input 'Remarks'";
                return;
            }
            let data = { code: this.code, remark: this.remark };
            let result = await AXIOS("/investment/saveRemark", data);
            if (result.success) {
                this.backInvestmentList();
            }
        },
        async approveInvestment() {
            this.errMsg = '';
            if (this.status == null) {
                this.errMsg = "Please select 'Review result'";
                return;
            } else if (this.status == 'Rejected') {
                if (this.remark == '' || this.remark == null) {
                    this.errMsg = "Please input 'Remarks'";
                    return;
                }
            }
            if (this.loading) return; // avoid repeat submit
            this.loading = true;
            let data = { code: this.code, remark: this.remark, status: this.status };
            let result = await AXIOS("/investment/approveInvestment", data);
            if (result.success) {
                this.backInvestmentList();
            }
        }
    }
}
</script>

<style scoped>
    .heading { width:1100px; }
</style>